var React = require('react');

function FavoriteFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m12,21l-1.45-1.3c-1.68-1.52-3.08-2.83-4.18-3.93s-1.98-2.09-2.63-2.96-1.1-1.68-1.36-2.41c-.26-.73-.39-1.48-.39-2.25,0-1.57.53-2.88,1.58-3.93s2.36-1.58,3.93-1.58c.87,0,1.69.18,2.48.55s1.46.88,2.03,1.55c.57-.67,1.24-1.18,2.03-1.55s1.61-.55,2.48-.55c1.57,0,2.88.53,3.93,1.58s1.58,2.36,1.58,3.93c0,.77-.13,1.52-.39,2.25-.26.73-.71,1.54-1.36,2.41s-1.53,1.86-2.63,2.96-2.49,2.41-4.18,3.93l-1.45,1.3Z"}));
}

FavoriteFilled.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = FavoriteFilled;

FavoriteFilled.default = FavoriteFilled;
